import { render } from "./designSelect.vue?vue&type=template&id=6af1fb1f&scoped=true"
import script from "./designSelect.vue?vue&type=script&lang=js"
export * from "./designSelect.vue?vue&type=script&lang=js"

import "./designSelect.vue?vue&type=style&index=0&id=6af1fb1f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af1fb1f"]])

export default __exports__